import { Outlet, createRootRoute } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { Layout } from "@/modules/layout/Layout.tsx";
import { ConfigDataProvider } from "@/dataProviders/ConfigDataProvider.tsx";
import { BankDataProvider } from "@/dataProviders/BankDataProvider.tsx";
import { PageNotFoundError } from "@/components/PageNotFoundError.tsx";

export const Route = createRootRoute({
  component: () => (
    <ConfigDataProvider>
      <BankDataProvider>
        <Layout>
          <Outlet />
        </Layout>

        <TanStackRouterDevtools />
      </BankDataProvider>
    </ConfigDataProvider>
  ),
  notFoundComponent: () => <PageNotFoundError />,
});
